<script setup>
/* eslint-disable */
import { useCurrenciesStore } from '@/stores/currencies';
import { closeModal, openModal } from '@kolirt/vue-modal'
import commonSvgs from '@/assets/svgs/commonSvgs.json';
import { useMissionsStore } from '@/stores/missions';
import MissionsSidebar from './MissionsSidebar.vue';
import { computed } from 'vue';

const currencyStore = useCurrenciesStore();
const missionsStore = useMissionsStore();

const svg_data = commonSvgs;

const props = defineProps({
	mission: {
		type: Object,
		required: true,
	},
});
const selectMission = (mission_id) => {
	missionsStore.setSelectedMission(mission_id);
	closeModal();
	setTimeout(() => {
		openModal(MissionsSidebar).then((data) => {}).catch(() =>{});
	}, 500);
}

const displayRewards = computed(() => {
	const rewards = [];

	const freebet_dynamic = props.mission.freebet_type === 'dynamic';
	const freespin_dynamic = props.mission.freespin_type === 'dynamic';
	const freebet_amount = props.mission.rewards?.freebet_amount;
	const freespin_quantity = props.mission.rewards?.freespin_quantity;

	if (freebet_dynamic) {
		rewards.push({
			type: 'freebet',
			dynamic: true,
		});
	} else if (freebet_amount) {
		rewards.push({
			type: 'freebet',
			amount: freebet_amount,
		});
	}

	if (freespin_dynamic) {
		rewards.push({
			type: 'freespin',
			dynamic: true,
		});
	} else if (freespin_quantity) {
		rewards.push({
			type: 'freespin',
			amount: freespin_quantity,
		});
	}

	return rewards;
});

</script>
<template>
	<div class="background">
		<div class="title">
			<img src="/assets/white_sport_icons/Archery.svg" alt="">
			<h6>{{ $t('missions.missions') }}</h6>
			<a @click="closeModal" style="cursor: pointer;">
				<object v-html="svg_data.form_cross_white"></object>
			</a>
		</div>
		<div class="title_container">
			<h6>{{ props.mission.name }}</h6>
		</div>

		<div class="subtitle_container">
			<h6 v-if="props.mission.mission_type === 'both'"> {{ $t('missions.complete_and_rewards') }}</h6>
			<h6 v-else> {{ $t('missions.complete_and_reward') }}</h6>
		</div>

		<div class="item_container" v-if="displayRewards.length">
			<div class="item" style="text-align: center;">
				<div style="display: flex; align-items: center; justify-content: center; gap: 30px;">
					<div v-for="(reward, index) in displayRewards" :key="index" style="text-align: center;">
						<img
							:src="reward.type === 'freebet' ? '/assets/images/receipt.svg' : '/assets/images/mission_slot.svg'"
							:style="reward.type === 'freebet' ? 'width: 60px; height: 65px;' : 'width: 70px; height: 65px;'"
							alt=""
						/>
						<template v-if="reward.dynamic">
							<div style="display: flex; flex-direction: column; align-items: center;">
								<Popper arrow hover openDelay="100" closeDelay="100" placement="bottom">
									<div style="display: flex; align-items: center; gap: 5px; cursor: help;">
										<p style="color: var(--white); margin: 0;">{{ $t('missions.dynamic') }}</p>
										<img src="/assets/images/info-icon.svg" alt="info" style="filter: brightness(0) saturate(100%) invert(84%) sepia(28%) saturate(287%) hue-rotate(57deg) brightness(95%) contrast(92%);" />
									</div>
										<template #content>
											<div class="tooltip">
												{{ reward.type === 'freebet' ? $t('missions.the_freebet_reward_is_dynamic') : $t('missions.the_freespin_reward_is_dynamic') }}
											</div>
										</template>
								</Popper>
							</div>
						</template>

						<template v-else>
							<h2 style="margin: 0; font-size: 1.5rem;">
								{{ reward.amount }} <span v-if="reward.type === 'freebet'">{{ currencyStore.getCurrencySymbol }}</span>
							</h2>
							<p style="color: var(--white);">
								{{ reward.type === 'freebet' ? $t('betslip.freebet') : $t('general.freespins') }}
							</p>
						</template>
					</div>
				</div>
			</div>
		</div>

		<div class="button_position">
			<div class="button_container">
				<button class="btn-small btn-secondary" style="width: 120px;" @click="selectMission(props.mission.id)">{{ $t('missions.learn_more') }}</button>
			</div>
		</div>
	</div>
</template>
<style scoped>
.tooltip {
	width: 130px;
	background-color: var(--primary);
	padding: 5px 0;
	text-align: center;
	border: 1px solid var(--primary);
	border-radius: 10px !important;
	font-size: 10px;
	color: var(--white);
}
:deep(.popper) {
	background-color: var(--primary);
	padding: 20px;
	border-radius: 20px;
	font-weight: bold;
	margin-right: 30px;
}

:deep(.popper #arrow::before) {
	background: var(--primary);
	left: 0px;
}
:deep(.popper:hover),
:deep(.popper:hover > #arrow::before) {
	background: var(--primary);
}
.title {
	display: grid;
	grid-template-columns: 24px 1fr 24px;
	align-items: center;
	gap: 10px;
	padding: 10px;
}
.title img {
	width: 24px;
}
.title h6 {
	color: var(--white);
	margin-top: -2px;
}
.background {
	background-image: url('../../../../public/assets/images/missions_background.jpg');
	background-size: contain;
	background-repeat: no-repeat;
	min-height: 535px;
	min-width: 320px;
}
.title_container {
	padding-top: 10%;
	text-align: center;
	color: var(--white);
}
.subtitle_container {
	text-align: center;
	color: var(--white);
	margin-top: 5%;
}

.item {
	display:flex;
	justify-content: center;
	align-items: center;
	margin-top: 60px;
	flex-direction: column;
}
.item h2 {
	color: var(--secondary);
}

.button_position {
	position: absolute;
	bottom: 50px;
	width: 100%;
}

.button_container {
	display: flex;
	justify-content: center;
}
</style>